import React, {useState} from 'react';
import './css/SideBarLayout.css';

import SideBarButton from './SideBarButton';


function SideBarLayout(props){
    console.log(props.pages)
    const [tab, setTab] = useState(0)
    const handleTabClick = () => {
        console.log("i")
        setTab(1);
    }
    return (
        <div>
            <div className="sidebar">
                {props.pages.map((page, index) => {
                    return <SideBarButton onClick={() => setTab(index)} key={index} text={page[0]} />
                })}
            </div>
            <div className="mainpage">
                {props.pages[tab][1]}
            </div>
        </div>
    )
}

export default SideBarLayout